import React from "react";
import { toast } from "react-toastify";

export const toastify = (message, status) => {
  if (status === "success") {
    toast.success(message, {
      position: "top-center",
      //   autoClose: 4000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      className: "toast-message",
    });
  } else {
    toast.error(message, {
      position: "top-center",
      autoClose: 2500,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      toastId: "error-toast",
      className: "toast-message",
    });
  }
};

/**
 * Display notification toast in the style used for FCM notifications
 * @param {string} title - The notification title
 * @param {string} body - The notification body (optional)
 */
const renderBodyWithLinks = (text) => {
  if (!text) return null;
  const parts = text.split(/(https?:\/\/[^\s<>"]+)/gi);
  return parts.map((part, i) =>
    /^https?:\/\//i.test(part) ? (
      <a key={i} href={part} target="_blank" rel="noopener noreferrer" className="viewLink">
        View
      </a>
    ) : (
      part
    )
  );
};

export const showNotificationToast = (title, body) => {
  if (!title && !body) {
    return;
  }

  toast.info(
    <div>
      <strong>{title}</strong>
      {body && <div style={{ marginTop: "4px" }}>{renderBodyWithLinks(body)}</div>}
    </div>,
    {
      position: "top-right",
      autoClose: 2500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    }
  );
};